import { render } from "./AuthView.vue?vue&type=template&id=1b448dcc&scoped=true&ts=true"
import script from "./AuthView.ts?vue&type=script&lang=ts"
export * from "./AuthView.ts?vue&type=script&lang=ts"

import "./AuthView.scss?vue&type=style&index=0&id=1b448dcc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b448dcc"]])

export default __exports__